import apiClient from "@repo/ui/lib/apiClient";
import { waitForSessionId } from "@repo/ui/lib/tabSessionId";
import type {
  PromoCodeValidationResponse,
  PromoCodeValidationResponseV2,
} from "@repo/ui/types/promotion";

export const validatePromotionCode = async (
  promoCode: string,
  fromDate?: string,
  toDate?: string,
  tabSessionId?: string | null,
): Promise<PromoCodeValidationResponse> => {
  const url = `v1/promotion/${promoCode}?fromDate=${fromDate}&toDate=${toDate}`;

  try {
    let sessionId = tabSessionId;
    if (!sessionId) {
      sessionId = await waitForSessionId();
      if (!sessionId) {
        throw new Error("Failed to get session ID for promo code validation");
      }
    }

    const response = await apiClient<PromoCodeValidationResponse>(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      withAuth: true,
      tabSessionId: sessionId,
    });

    return response;
  } catch (error) {
    console.error("Error validating promo code:", error);
    return {
      messages: [
        {
          code: "ERROR",
          type: "Error",
          value: "Failed to validate promo code",
          status: 500,
        },
      ],
    };
  }
};

export const validatePromotionCodev2 = async (
  promoCode: string,
  tabSessionId?: string | null,
): Promise<PromoCodeValidationResponseV2> => {
  const url = `/v1/promotion/${promoCode}/validate`;

  try {
    let sessionId = tabSessionId;
    if (!sessionId) {
      sessionId = await waitForSessionId();
      if (!sessionId) {
        throw new Error("Failed to get session ID for promo code validation");
      }
    }

    const response = await apiClient<PromoCodeValidationResponseV2>(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      withAuth: true,
      tabSessionId: sessionId,
    });

    return response;
  } catch (error) {
    console.error("Error validating promo code:", error);
    return {
      messages: [
        {
          code: "ERROR",
          type: "Error",
          value: "Failed to validate promo code",
          status: 500,
        },
      ],
      data: { isValid: false },
    };
  }
};
